import { observer } from "mobx-react";
import { FC, useState } from "react";
import styled from "styled-components";

const CheckboxContainer = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  cursor: pointer;
`;
const CheckboxInput = styled.label`
  // width: 15px;
  // height: 15px;
  // border: 1px solid #999;
  // border-radius: 50px;
  // position: relative;
`;
const CheckboxText = styled.p``;

const Checkbox: FC<{ text: string; checked?: boolean; onChange: Function }> = observer(({ text, checked = false, onChange }) => {
  const [bool, setBool] = useState<boolean>(checked);

  return (
    <CheckboxContainer
      onClick={() => {
        setBool((prev) => !prev);
        onChange(bool);
      }}
    >
      <CheckboxInput>
        <input
          type="checkbox"
          checked={bool}
          onChange={({ target }) => {
            setBool(target.checked);
          }}
        />
      </CheckboxInput>
      <CheckboxText>{text}</CheckboxText>
    </CheckboxContainer>
  );
});

export default Checkbox;
